// extracted by mini-css-extract-plugin
export var card = "_mg-1";
export var summary = "_mg-0";
export var unreadDot = "_mg-2";